import JSONPretty from 'react-json-pretty'

const theme = {
  main: 'line-height:1.2;color:#000;background:#FFF;overflow:auto',
  error: 'line-height:1.2;color:#000;background:#FFF;overflow:auto;',
  key: 'color:#000;',
  string: 'color:#000;',
  value: 'color:#000;',
  boolean: 'color:#000;',
}

type Props = {
  data: unknown
}

export const JsonViewer = ({ data }: Props) => {
  return <JSONPretty data={data} theme={theme} />
}
